import formCollection from "../../server/formCollection";
import dynamicFunctions from "../../config/dynamicFunctions";
import formSubmitterServer from "../../server/formSubmitter";
import documentGroupServer from "../../server/documentGroup";
import { computeExpression } from "../../helpers/dynamicComputer";
import {
  getFormBuilderComponents,
  getElementComponentData,
  getDependencies
} from "../../helpers/formBuilder";
import serverEForm from "../../server/eForm";
import formVersionServer from "../../server/formVersion";
import { formatDateTimeMysql } from "../../helpers/date";
import Vue from 'vue';

function getSignatureCounter(formValues) {
  var count = 0;
  var completed = 0;
  for (var value in formValues) {
    if (value.startsWith("Signature")) {
      count++;
      if (formValues[value]) completed++;
    }
  }
  return {
    totalSignatures: count,
    completedSignatures: completed
  };
}

const computeFormSubmitterValue =
({
  elementId,
  value,
  defaultValue,
  form,
  statements,
  preCode,
  stateForm,
  selectedLocation
}) => {
  let result = value;

  let formData = stateForm;
  if (form) {
    try {
      formData = {
        json: form.version ? form.version.content : form.current.content,
        values: form.submit ? form.submit.results : {},
        metadata: stateForm.metadata,
        document: form.submit,
        collections: stateForm.collections,
        client: form.client,
        name: form.name,
        otherResults: form.otherResults ? form.otherResults : [],
        showType: form.showType ? form.showType : stateForm.showType,
        scheduleEvent: form.scheduleEvent
      };
    } catch (error) {
      formData = form;
    }
  }
  if (typeof value == "string" && value.startsWith("computed:")) {
    let expression = getVariablesCodeForCompute({
      formScript: formData.json.properties.script,
      values: formData.values,
      metadata: formData.metadata,
      document: formData.document,
      collections: formData.collections,
      client: formData.client,
      element: {
        id: elementId
      },
      form: {
        name: formData.name
      },
      location: selectedLocation,
      otherResults: formData.otherResults,
      showType: formData.showType,
      scheduleEvent: formData.scheduleEvent
    });
    if (preCode) expression += " \n" + preCode + " \n";
    if (statements) expression += " \n" + `${value.slice(9)};`;
    else {
      expression +=
        " \n" +
        `var _result = ${value.slice(9)}; \n JSON.stringify(_result)`;
    }

    const computeResult = computeExpression(
      expression,
      statements ? true : false,
      {
        setComponentValue: (conponentId, componentValue) => {
          stateForm.values = {
            ...stateForm.values,
            [conponentId]: componentValue
          };
        }
      }
    );
    if (computeResult == null) result = defaultValue;
    else result = computeResult;
  }

  return result;
};

const superComputeFormSubmitterValue =
({
  elementId,
  property,
  value,
  defaultValue,
  form,
  statements,
  preCode,
  oneTimeBindingValues,
  stateForm,
  selectedLocation
}) => {
  let result = value;
  if (typeof value == "string") {
    if (statements) result = result.replaceAll("\n", ";");
    let re = /\{\{(?:(?!\}\}).)*\}\}/g;
    const matches = [...result.matchAll(re)];
    if (
      matches.length == 1 &&
      value.startsWith("{{") &&
      value.endsWith("}}")
    ) {
      let oneTimeBindingKey = `${elementId}${
        property ? "_" + property : ""
      }`;
      if (oneTimeBindingKey in oneTimeBindingValues) {
        result = oneTimeBindingValues[oneTimeBindingKey];
      } else {
        //let isOneTimeBinding = false;
        let toComputeValue = value.slice(2, value.length - 2);
        if (toComputeValue.startsWith("::")) {
          //isOneTimeBinding = true;
          toComputeValue = toComputeValue.slice(2, value.length);
        }
        result = computeFormSubmitterValue({
          elementId,
          value: "computed:" + toComputeValue,
          defaultValue,
          form,
          statements,
          preCode,
          stateForm,
          selectedLocation
        });
        /*if (isOneTimeBinding && hasValue(result)) {
          state.form.oneTimeBindingValues[oneTimeBindingKey] = result;
        }*/ //move this logic
      }
    } else {
      for (let index = matches.length - 1; index >= 0; index--) {
        const match = matches[index];
        const matchStr = match[0];
        const matchIndex = match["index"];

        let computedValue = "";

        let oneTimeBindingKey = `${elementId}${
          property ? "_" + property : ""
        }_${matchIndex}`;
        if (oneTimeBindingKey in oneTimeBindingValues) {
          computedValue =
            oneTimeBindingValues[oneTimeBindingKey];
        } else {
          //let isOneTimeBinding = false;
          let toComputeValue = matchStr.slice(2, matchStr.length - 2);
          if (toComputeValue.startsWith("::")) {
            //isOneTimeBinding = true;
            toComputeValue = toComputeValue.slice(
              2,
              toComputeValue.length
            );
          }
          computedValue = computeFormSubmitterValue({
            elementId,
            value: "computed:" + toComputeValue,
            defaultValue,
            form,
            statements,
            preCode,
            stateForm,
            selectedLocation
          });

          /*if (isOneTimeBinding && hasValue(result)) {
            state.form.oneTimeBindingValues[oneTimeBindingKey] =
              computedValue;
          }*/ //move this logic
        }
        result =
          result.substring(0, matchIndex) +
          computedValue +
          result.substring(matchIndex + matchStr.length);
      }
    }
    computeFormSubmitterValue({
      elementId,
      value: result,
      defaultValue: "",
      form,
      preCode,
      stateForm,
      selectedLocation
    });
  }
  return result;
};

const getVariablesCodeForCompute = ({
  formScript,
  values,
  metadata,
  document,
  collections,
  client,
  element,
  form,
  location,
  otherResults,
  showType,
  scheduleEvent
}) => {
  let variablesCode = [formScript, "var components = {};"];
  dynamicFunctions.forEach((func) => variablesCode.push(func));
  let controlIds = Object.keys(values);
  controlIds = [...new Set(controlIds.concat(Object.keys(metadata)))];
  for (let index = 0; index < controlIds.length; index++) {
    const controlId = controlIds[index];

    variablesCode.push(`
      components['${controlId}']={
        Value: ${JSON.stringify(values[controlId])},
        ${
          metadata[controlId]
            ? Object.keys(metadata[controlId])
                .map(
                  (metadataProperty) =>
                    `${metadataProperty}: ${JSON.stringify(
                      metadata[controlId][metadataProperty]
                    )}`
                )
                .join(",")
            : ""
        }
      };
    `);
  }
  variablesCode.push(`
    var document = ${JSON.stringify(document)};
  `);

  variablesCode.push(`
    var collections = ${JSON.stringify(collections)};
  `);

  variablesCode.push(`
    var client = ${JSON.stringify(client)};
  `);

  variablesCode.push(`
    var patient = client;
  `);

  variablesCode.push(`
    var form = ${JSON.stringify(form)};
  `);

  variablesCode.push(`
    var element = ${JSON.stringify(element)};
  `);

  variablesCode.push(`
    var location = ${JSON.stringify(location)};
  `);

  variablesCode.push(`
    var otherResults = ${JSON.stringify(otherResults)};
  `);

  variablesCode.push(`
    var showType = ${JSON.stringify(showType)};
  `);
  
  variablesCode.push(`
    var scheduleEvent = ${JSON.stringify(scheduleEvent)};
  `);

  return variablesCode.join("\n");
};

const initialFormJson = () => ({
  elType: "Form",
  id: "form1",
  properties: {
    script: "",
    scoreFunctionBody: ""
  },
  grid: {
    components: []
  },
  layout: {
    rows: []
  }
});

const hasValue = (variable) => {
  if (typeof variable == "string") {
    return variable != "";
  }
  if (typeof variable == "number") {
    return variable != 0;
  }
  if (variable instanceof Array) {
    return variable.length != 0;
  }
  return false;
};

const formSubmitterModule = {
  namespaced: true,
  state: () => ({
    form: {
      id: null,
      name: "",
      json: initialFormJson(),
      values: {},
      computedProperties: {},
      metadata: {},
      document: {},
      client: {},
      eoc: {},
      versionId: "",
      collections: {},
      otherResults: [],
      showType: "",
      errors: {},
      hasUnsavedChanges: false,
      oneTimeBindingValues: {},
      currentPage: 0,
      dependencies: {},
      properties: {}
    },
    clipboard: localStorage.getItem("documentClipboard")
      ? JSON.parse(localStorage.getItem("documentClipboard"))
      : {
          formId: null,
          versionId: null,
          values: {}
        },
    loadingPage: false
  }),
  mutations: {
    async setInitialValues(state) {
      state.form = {
        id: null,
        name: "",
        json: initialFormJson(),
        values: {},
        computedProperties: {},
        metadata: {},
        document: {},
        client: {},
        eoc: {},
        versionId: "",
        collections: {},
        errors: {},
        hasUnsavedChanges: false,
        otherResults: [],
        showType: "",
        oneTimeBindingValues: {},
        currentPage: 0,
        dependencies: {},
        properties: {}
      };
    },
    initializeCollections(
      state, 
      collections
    ) {
      state.form.collections = collections;
    },
    initializeFormSubmitterForm(
      state,
      {
        formId,
        formName,
        version,
        client,
        eoc,
        document,
        otherResults,
        defaultValues,
        showType,
        selectedLocation = "",
        scheduleEvent
      }
    ) {
      state.form.client = client;
      state.form.eoc = eoc;
      state.form.scheduleEvent = scheduleEvent
      state.form.id = formId;
      state.form.name = formName;
      state.form.json = version.content;
      state.form.versionId = version.id;
      state.form.values = document
        ? document.results
        : defaultValues
        ? defaultValues
        : {};
      state.form.computedProperties = {};
      state.form.document = document
        ? {
            status: document.status,
            effectiveDate: formatDateTimeMysql(document.effectiveDate)
          }
        : {
            status: "Draft",
            new: true,
            effectiveDate: formatDateTimeMysql(new Date())
          };
      state.form.metadata = {};
      state.form.errors = {};
      state.form.hasUnsavedChanges = false;
      state.form.oneTimeBindingValues = {};
      state.form.dependencies = version.content.dependencies;
      
      if(!state.form.dependencies && version.id) {
        state.form.dependencies = getDependencies(version.content.layout);
        formVersionServer.updateDependencies(version.id, state.form.dependencies);
      }
      state.form.otherResults = otherResults ? otherResults : [];
      state.form.showType = showType;
      state.form.currentPage = 0;
      
      let setInitialValues = !defaultValues && (!document || !document.results);
      
      version.content.layout.rows.forEach(row => {
        row.columns.forEach(col => {
          col.components.forEach(component => {
            if (component.properties) {
              state.form.properties[component.id] = { ...component.properties};
              Vue.set(state.form.computedProperties, component.id, { ...component.properties});
              
              let componentInitialData = getElementComponentData(component.elType, component.version);
              if (setInitialValues) {
                state.form.values[component.id] = componentInitialData.defaultAttrs.properties.value;
              }


              for (const [key, value] of Object.entries(component.properties)) {
                if (setInitialValues) {
                  state.form.values[component.id] = state.form.computedProperties[component.id].value;
                }
                if (typeof value == "string" && value.includes("{{") &&
                value.includes("}}")){
                  let computedValue = superComputeFormSubmitterValue({
                    elementId: component.id,
                    property: key,
                    value,
                    defaultValue: componentInitialData.defaultAttrs.properties[key],
                    form: null,
                    oneTimeBindingValues: state.form.oneTimeBindingValues,
                    stateForm: state.form,
                    selectedLocation});
          
                  //onetime logic here  
          
                  state.form.computedProperties[component.id][key] = computedValue;
                  if (key == "value" && !document) {
                    state.form.values[component.id] = computedValue;
                  }
                }
                else if(component.elType == "Table") {
                  if (key == "columns") {
                    let tableColumns = superComputeFormSubmitterValue({
                      elementId: `${component.id}_columns`,
                      property: "items",
                      value: value,
                      defaultValue: [],
                      form: null,
                      oneTimeBindingValues: state.form.oneTimeBindingValues,
                      stateForm: state.form,
                      selectedLocation
                    });

                    Vue.set(state.form.computedProperties, `${component.id}_columns`, tableColumns);

                    value.forEach((tableCol, columnIndex) => {
                      let label = superComputeFormSubmitterValue({
                        elementId: `${component.id}_columns_${columnIndex}`,
                        property: "label",
                        value: tableCol.label,
                        defaultValue: "",
                        fform: null,
                        oneTimeBindingValues: state.form.oneTimeBindingValues,
                        stateForm: state.form,
                        selectedLocation
                      });

                      Vue.set(state.form.computedProperties,`${component.id}_columns_${columnIndex}`, label);
                    });
                  }

                  if (key == "items") {
                    let tableItems = superComputeFormSubmitterValue({
                      elementId: `${component.id}_items`,
                      property: "items",
                      value: value,
                      defaultValue: [],
                      form: null,
                      oneTimeBindingValues: state.form.oneTimeBindingValues,
                      stateForm: state.form,
                      selectedLocation
                    });

                    Vue.set(state.form.computedProperties, `${component.id}_items`, tableItems);

                    value.forEach((item, itemIndex) => {
                      const itemKeys = Object.keys(item);
                      for (let index = 0; index < itemKeys.length; index++) {
                        const itemKey = itemKeys[index];
                        let res = superComputeFormSubmitterValue({
                          elementId: `${component.id}_items_${itemIndex}_columns_${index}`,
                          property: itemKey,
                          value: item[itemKey],
                          defaultValue: "",
                          form: null,
                          oneTimeBindingValues: state.form.oneTimeBindingValues,
                          stateForm: state.form,
                          selectedLocation
                        });

                        Vue.set(state.form.computedProperties, `${component.id}_items_${itemIndex}_columns_${index}`, res);
                      }
                    });
                  }
                }
              }
            }
          });
        });
      });

      setTimeout(() => {
        state.form.values = {
          ...state.form.values
        };
      }, 0);
    },
    async fetchCollections(state, { json }) {
      let serverCollections = {};
      serverCollections = await formCollection.query();

      const collections = {};
      const jsonString = JSON.stringify(json);
      for (let index = 0; index < serverCollections.length; index++) {
        const serverCollection = serverCollections[index];
        if (jsonString.indexOf(`collections.${serverCollection}`) > -1) {
          const collectionResult = await formCollection.get(serverCollection);
          collections[serverCollection] = collectionResult.items;
        }
      }
      state.form.collections = {
        ...state.form.collections,
        ...collections
      };
    },
    setDocumentData(state, { status, effectiveDate }) {
      state.form = {
        ...state.form,
        document: {
          status: status,
          effectiveDate: effectiveDate
        }
      };
    },
    setFormSubmitterComponentValue(
      state,
      {
        controlId,
        controlValue,
        userAction = false,
        hasUnsavedChanges = true,
        form = null,
        rootState
      }
    ) {
      if (
        (controlValue || state.form.values[controlId]) &&
        controlValue != state.form.values[controlId] &&
        (!Array.isArray(controlValue) || controlValue.length > 0) &&
        userAction
      ) {
        state.form.hasUnsavedChanges = hasUnsavedChanges;
      }
      state.form.values = {
        ...state.form.values,
        [controlId]: controlValue
      };
      
      let index = controlId.indexOf("_");
      const controlIdSubstring = controlId.substring(0, index < 0 ? controlId.length : index);
      if (state.form.dependencies[controlIdSubstring]) {
        state.form.dependencies[controlIdSubstring].forEach((key) => {
        if (key.type && key.type == "Table"){
          if (key.property == "columns") {
            let value = superComputeFormSubmitterValue({
              elementId: `${key.element}_columns_${key.columnIndex}`,
              property: "label",
              value: state.form.properties[key.element][key.property][key.columnIndex].label,
              form,
              oneTimeBindingValues: state.form.oneTimeBindingValues,
              stateForm: state.form,
              selectedLocation: rootState.layout.selectedLocation});
    
              state.form.computedProperties[`${key.element}_columns_${key.columnIndex}`] = value;
          }
          if (key.property == "items") {
            let value = superComputeFormSubmitterValue({
              elementId: `${key.element}_items_${key.itemIndex}_columns_${key.columnIndex}`,
              property: key.itemKey,
              value: state.form.properties[key.element][key.property][key.itemIndex][key.itemKey],
              form,
              oneTimeBindingValues: state.form.oneTimeBindingValues,
              stateForm: state.form,
              selectedLocation: rootState.layout.selectedLocation});
    
              state.form.computedProperties[`${key.element}_items_${key.itemIndex}_columns_${key.columnIndex}`] = value;
          }
        }
        else if (key.property != "value" || key.element.includes('Html') || key.element.includes('Text') || key.element.includes('SectionHeader')) {
          let allDependentValues = Object.keys(state.form.values).filter(elem => elem == key.element || elem.startsWith(key.element + "_"));
          allDependentValues.forEach((keyElement) => {
            if (state.form.properties[keyElement]) {
              let value = superComputeFormSubmitterValue({
                elementId: keyElement,
                property: key.property,
                value: state.form.properties[keyElement][key.property],
                form,
                oneTimeBindingValues: state.form.oneTimeBindingValues,
                stateForm: state.form,
                selectedLocation: rootState.layout.selectedLocation});
      
                state.form.computedProperties[keyElement][key.property] = value;
              }
          })
        }

        //onetime logic here  

        state.form.computedProperties = {
          ...state.form.computedProperties
        };

        });
      }
    },
    initializeComponentValue(
      state,
      {
        controlId,
        properties,
        isTable = false,
        rootState
      }
    ) {
        state.form.properties[controlId] = { ...properties};
        Vue.set(state.form.computedProperties, controlId, { ...properties});

        for (const [key, value] of Object.entries(properties)) {
          if (typeof value == "string" && value.includes("{{") &&
          value.includes("}}")){
            let computedValue = superComputeFormSubmitterValue({
              elementId: controlId,
              property: key,
              value,
              defaultValue: "",
              form: null,
              oneTimeBindingValues: state.form.oneTimeBindingValues,
              stateForm: state.form,
              selectedLocation: rootState.layout.selectedLocation});
    
            state.form.computedProperties[controlId][key] = computedValue;
          }
          else if(isTable) {
            if (key == "columns") {
              let tableColumns = superComputeFormSubmitterValue({
                elementId: `${controlId}_columns`,
                property: "items",
                value: value,
                defaultValue: [],
                form: null,
                oneTimeBindingValues: state.form.oneTimeBindingValues,
                stateForm: state.form,
                selectedLocation: rootState.layout.selectedLocation
              });

              Vue.set(state.form.computedProperties, `${controlId}_columns`, tableColumns);

              value.forEach((tableCol, columnIndex) => {
                let label = superComputeFormSubmitterValue({
                  elementId: `${controlId}_columns_${columnIndex}`,
                  property: "label",
                  value: tableCol.label,
                  defaultValue: "",
                  fform: null,
                  oneTimeBindingValues: state.form.oneTimeBindingValues,
                  stateForm: state.form,
                  selectedLocation: rootState.layout.selectedLocation
                });

                Vue.set(state.form.computedProperties,`${controlId}_columns_${columnIndex}`, label);
              });
            }

            if (key == "items") {
              let tableItems = superComputeFormSubmitterValue({
                elementId: `${controlId}_items`,
                property: "items",
                value: value,
                defaultValue: [],
                form: null,
                oneTimeBindingValues: state.form.oneTimeBindingValues,
                stateForm: state.form,
                selectedLocation: rootState.layout.selectedLocation
              });

              Vue.set(state.form.computedProperties, `${controlId}_items`, tableItems);

              value.forEach((item, itemIndex) => {
                const itemKeys = Object.keys(item);
                for (let index = 0; index < itemKeys.length; index++) {
                  const itemKey = itemKeys[index];
                  let res = superComputeFormSubmitterValue({
                    elementId: `${controlId}_items_${itemIndex}_columns_${index}`,
                    property: itemKey,
                    value: item[itemKey],
                    defaultValue: "",
                    form: null,
                    oneTimeBindingValues: state.form.oneTimeBindingValues,
                    stateForm: state.form,
                    selectedLocation: rootState.layout.selectedLocation
                  });

                  Vue.set(state.form.computedProperties, `${controlId}_items_${itemIndex}_columns_${index}`, res);
                }
              });
            }
          }
        }
        if (!state.form.values[controlId]) {
          Vue.set(state.form.values, controlId, state.form.computedProperties[controlId].value);
        }
    },
    setFormSubmitterComponentMetadata(state, { controlId, controlMetadata }) {
      state.form.metadata = {
        ...state.form.metadata,
        [controlId]: controlMetadata
      };
    },
    setFormSubmitterFormErrors(state, { errors }) {
      state.form.errors = errors;
    },
    setFormSubmitterFormHasUnsavedChanges(state, { hasUnsavedChanges }) {
      state.form.hasUnsavedChanges = hasUnsavedChanges;
    },
    copyFormSubmitterValues(state) {
      const values = { ...state.form.values };
      Object.keys(values).forEach((key) => {
        if (
          key.startsWith("Signature") ||
          key.startsWith("ClientAllergies") ||
          key.startsWith("ClientDiagnosisCodes") ||
          key.startsWith("ClientVitals") ||
          key.startsWith("TreatmentPlanObjectives")
        ) {
          delete values[key];
        }
      });
      state.clipboard.values = values;
      state.clipboard.versionId = state.form.versionId;
      state.clipboard.formId = state.form.id;
      localStorage.setItem(
        "documentClipboard",
        JSON.stringify(state.clipboard)
      );
    },
    pasteFormSubmitterValues(state) {
      state.form.values = { ...state.form.values, ...state.clipboard.values };
      state.form.hasUnsavedChanges = true;
    },
    setOneTimeBindingValues(state, { oneTimeBindingValues }) {
      state.form.oneTimeBindingValues = oneTimeBindingValues;
    },
    setCurrentPage(state, { page }) {
      state.form.currentPage = page;
      const element = document.getElementById("form-paginator");
      if (element) {
        element.scrollIntoView();
      }
    },
    setLoadingPage(state, loadingPage) {
      state.loadingPage = loadingPage;
    },
    setComputedProperty(state, {elementId, property, value}){
      if (elementId && property) {
        if (!state.form.computedProperties[elementId]) {
          state.form.computedProperties[elementId] = {};
        }
        state.form.computedProperties[elementId][property] = value;
      }
    }
  },
  actions: {
    async initializeFormSubmitterForm(
      {commit}, 
      {
        formId,
        formName,
        version,
        client,
        eoc,
        document,
        isEForm,
        eFormToken,
        otherResults,
        defaultValues,
        showType,
        selectedLocation = "",
        scheduleEvent
      }
    ) {
      let serverCollections = {};

      if (isEForm)
        serverCollections = await serverEForm.queryCollections(eFormToken);
      else {
        serverCollections = await formCollection.query();
      }

      const collections = {};
      const jsonString = JSON.stringify(version.content);
      for (let index = 0; index < serverCollections.length; index++) {
        const serverCollection = serverCollections[index];
        if (jsonString.indexOf(`collections.${serverCollection}`) > -1) {
          if (isEForm) {
            const collectionResult = await serverEForm.queryCollection(
              eFormToken,
              serverCollection
            );
            collections[serverCollection] = collectionResult.items;
          } else {
            const collectionResult = await formCollection.get(serverCollection);
            collections[serverCollection] = collectionResult.items;
          }
        }
      }
      commit("initializeCollections", collections);
      commit("initializeFormSubmitterForm", 
      {
        formId,
        formName,
        version,
        client,
        eoc,
        document,
        otherResults,
        defaultValues,
        showType,
        selectedLocation,
        scheduleEvent
      });
    },
    setFormSubmitterComponentValue(
    {commit, rootState},
      data
    ) {
      data = {
        ...data,
        rootState
      };
      commit("setFormSubmitterComponentValue", data);
    },
    initializeComponentValue(
      {commit, rootState},
        data
      ) {
        data = {
          ...data,
          rootState
        };
        commit("initializeComponentValue", data);
      },
    setCurrentPage(context, { page }) {
      context.commit("setLoadingPage", true);
      context.dispatch("layout/show", '',  {
        root: true
      });
      setTimeout(async () => {
        context.commit("setCurrentPage", { page: page });
        await Vue.nextTick();
        context.dispatch("layout/hide", '',  {
          root: true
        });
        context.commit("setLoadingPage", false);
      }, 0);
    },
    validateFormSubmitterForm(context) {
      let errors = {};
      let updatedCurrentPage = false;
      const components = getFormBuilderComponents(context.state.form.json);
      for (let index = 0; index < components.length; index++) {
        const component = components[index];
        const componentData = getElementComponentData(
          component.elType,
          component.version
        );
        let validationErrors = [];
        if (
          context.state.form.showType == "e-form" &&
          !component.properties.eFormEditable
        ) {
          continue;
        } else {
          validationErrors = componentData.validate({
            value: context.state.form.values[component.id],
            properties: component.properties
          });
        }
        if (validationErrors.length > 0) {
          errors[component.id] = validationErrors;
          if (!updatedCurrentPage) {
            context.commit("setCurrentPage", { page: component.page });
            updatedCurrentPage = true;
          }
        }
      }
      context.commit("setFormSubmitterFormErrors", { errors });
      return Object.keys(errors).length == 0;
    },
    copyFormValuesToClipboard(context) {
      context.commit("copyFormSubmitterValues");
      context.dispatch(
        "layout/showAlertSuccess",
        {
          message: "Copied to clipboard"
        },
        {
          root: true
        }
      );
    },
    pasteFormValuesFromClipboard(context) {
      if (context.state.clipboard.formId == context.state.form.id) {
        context.commit("pasteFormSubmitterValues");
        context.dispatch(
          "layout/showAlertSuccess",
          {
            message: "Content pasted"
          },
          {
            root: true
          }
          );
      } else {
        context.dispatch(
          "layout/showError",
          {
            message:
              "The format of the copied document doesn't match the current one. You can only copy between documents that are the same type."
          },
          {
            root: true
          }
        );
      }
    },
    async addFormSubmitterFile(context, data) {
      const response = await formSubmitterServer.upload(data);
      return response.id;
    },
    async updateFormSubmitterFile(context, data) {
      await formSubmitterServer.uploadUpdate(data);
    },
    async addFormGroupSubmitterFile(context, data) {
      const response = await documentGroupServer.upload(data);
      return response.id;
    },
    async updateFormGroupSubmitterFile(context, data) {
      const response = await documentGroupServer.uploadUpdate(data);
      return response.id;
    },
    async addFormSubmitterForm(
      context,
      {
        sharedDocumentId,
        documentGroupId,
        status,
        groupSessionId,
        effectiveDate,
        nextReviewDate,
        parentDocumentId,
        bakedLayout,
        scheduleEventId,
        scheduleEventParticipantId,
        notes,
        score,
        attachForm
      }
    ) {
      let submitId = "";
      const { totalSignatures, completedSignatures } = getSignatureCounter(
        context.state.form.values
      );
      const result = await formSubmitterServer.create(
        {
          results: context.state.form.values,
          formId: context.state.form.id,
          patientId: context.state.form.client.id,
          episodeOfCareId: context.state.form.eoc
            ? context.state.form.eoc.id
            : null,
          versionId: context.state.form.versionId,
          status,
          mode: "Results",
          documentGroupId,
          groupSessionId,
          bakedLayout,
          score: score != null ? score.toString() : score,
          effectiveDate,
          nextReviewDate,
          parentDocumentId,
          scheduleEventId,
          scheduleEventParticipantId,
          notes,
          totalSignatures,
          completedSignatures,
          attachForm: attachForm
        },
        sharedDocumentId
      );
      submitId = result.id;
      const documentRefNumber = result.documentRefNumber;
      return {
        submitId,
        documentRefNumber,
        totalSignatures,
        completedSignatures
      };
    },
    async editFormSubmitterForm(
      context,
      {
        submitId,
        documentGroupId,
        groupSessionId,
        status,
        effectiveDate,
        nextReviewDate,
        parentDocumentId,
        bakedLayout,
        scheduleEventId,
        scheduleEventParticipantId,
        notes,
        score,
        unlockReason
      }
    ) {
      const { totalSignatures, completedSignatures } = getSignatureCounter(
        context.state.form.values
      );
      await formSubmitterServer.update(submitId, {
        results: context.state.form.values,
        formId: context.state.form.id,
        patientId: context.state.form.client.id,
        episodeOfCareId: context.state.form.eoc.id,
        versionId: context.state.form.versionId,
        status,
        mode: "Results",
        documentGroupId,
        groupSessionId,
        bakedLayout,
        score: score != null ? score.toString() : score,
        effectiveDate,
        nextReviewDate,
        parentDocumentId,
        scheduleEventId,
        scheduleEventParticipantId,
        notes,
        unlockReason,
        totalSignatures,
        completedSignatures
      });
      return { totalSignatures, completedSignatures };
    },
    async bulkEditFormSubmitterForm(context, data) {
      return await formSubmitterServer.bulkUpdate(data);
    },
    async deleteFormSubmitterSubmit(context, { submitId }) {
      return await formSubmitterServer.delete(submitId);
    },
    computeFormSubmitterValue({commit, state, rootState},{
        elementId,
        property,
        value,
        defaultValue,
        form,
        statements,
        preCode
      }){
        let result = value;

        let formData = state.form;
        if (form) {
          try {
            formData = {
              json: form.version ? form.version.content : form.current.content,
              values: form.submit ? form.submit.results : {},
              metadata: state.form.metadata,
              document: form.submit,
              collections: state.form.collections,
              client: form.client,
              name: form.name,
              otherResults: form.otherResults ? form.otherResults : [],
              showType: form.showType ? form.showType : state.form.showType
            };
          } catch (error) {
            formData = form;
          }
        }
        if (typeof value == "string" && value.startsWith("computed:")) {
          let expression = getVariablesCodeForCompute({
            formScript: formData.json.properties.script,
            values: formData.values,
            metadata: formData.metadata,
            document: formData.document,
            collections: formData.collections,
            client: formData.client,
            element: {
              id: elementId
            },
            form: {
              name: formData.name
            },
            location: rootState.layout.selectedLocation,
            otherResults: formData.otherResults,
            showType: formData.showType
          });
          if (preCode) expression += " \n" + preCode + " \n";
          if (statements) expression += " \n" + `${value.slice(9)};`;
          else {
            expression +=
              " \n" +
              `var _result = ${value.slice(9)}; \n JSON.stringify(_result)`;
          }

          const computeResult = computeExpression(
            expression,
            statements ? true : false,
            {
              setComponentValue: (conponentId, componentValue) => {
                commit("setFormSubmitterComponentValue", {
                  controlId: conponentId,
                  controlValue: componentValue,
                  rootState: rootState
                })
              }
            }
          );
          if (computeResult == null) result = defaultValue;
          else result = computeResult;
        }
        commit("setComputedProperty", {elementId, property, result});

        return result;
      }
  },
  getters: {
    getFormSubmitterComponentValue: (state) => (controlId) => {
      return state.form.values[controlId];
    },
    computeFormSubmitterValue:
      (state, getters, rootState) =>
      ({
        elementId,
        property,
        value,
        defaultValue,
        form,
        statements,
        preCode
      }) => {
        let result = value;

        let formData = state.form;
        if (form) {
          try {
            formData = {
              json: form.version ? form.version.content : form.current.content,
              values: form.submit ? form.submit.results : {},
              metadata: state.form.metadata,
              document: form.submit,
              collections: state.form.collections,
              client: form.client,
              name: form.name,
              otherResults: form.otherResults ? form.otherResults : [],
              showType: form.showType ? form.showType : state.form.showType
            };
          } catch (error) {
            formData = form;
          }
        }
        if (typeof value == "string" && value.startsWith("computed:")) {
          let expression = getVariablesCodeForCompute({
            formScript: formData.json.properties.script,
            values: formData.values,
            metadata: formData.metadata,
            document: formData.document,
            collections: formData.collections,
            client: formData.client,
            element: {
              id: elementId
            },
            form: {
              name: formData.name
            },
            location: rootState.layout.selectedLocation,
            otherResults: formData.otherResults,
            showType: formData.showType
          });
          if (preCode) expression += " \n" + preCode + " \n";
          if (statements) expression += " \n" + `${value.slice(9)};`;
          else {
            expression +=
              " \n" +
              `var _result = ${value.slice(9)}; \n JSON.stringify(_result)`;
          }

          const computeResult = computeExpression(
            expression,
            statements ? true : false,
            {
              setComponentValue: (conponentId, componentValue) => {
                state.form.values = {
                  ...state.form.values,
                  [conponentId]: componentValue
                };
              }
            }
          );
          if (computeResult == null) result = defaultValue;
          else result = computeResult;
        }
        if (elementId && property) {
          if (!state.form.computedProperties[elementId]) {
            state.form.computedProperties[elementId] = {};
          }
          state.form.computedProperties[elementId][property] = result;
        }

        return result;
      },
    superComputeFormSubmitterValue:
      (state, getters) =>
      ({
        elementId,
        property,
        value,
        defaultValue,
        form,
        statements,
        preCode,
        componentPage
      }) => {
        if (componentPage && state.form.currentPage != componentPage)
          return defaultValue;
        let result = value;
        if (typeof value == "string") {
          if (statements) result = result.replaceAll("\n", ";");
          let re = /\{\{(?:(?!\}\}).)*\}\}/g;
          const matches = [...result.matchAll(re)];
          if (
            matches.length == 1 &&
            value.startsWith("{{") &&
            value.endsWith("}}")
          ) {
            let oneTimeBindingKey = `${elementId}${
              property ? "_" + property : ""
            }`;
            if (oneTimeBindingKey in state.form.oneTimeBindingValues) {
              result = state.form.oneTimeBindingValues[oneTimeBindingKey];
            } else {
              let isOneTimeBinding = false;
              let toComputeValue = value.slice(2, value.length - 2);
              if (toComputeValue.startsWith("::")) {
                isOneTimeBinding = true;
                toComputeValue = toComputeValue.slice(2, value.length);
              }
              result = getters.computeFormSubmitterValue({
                elementId,
                property,
                value: "computed:" + toComputeValue,
                defaultValue,
                form,
                statements,
                preCode
              });
              if (isOneTimeBinding && hasValue(result)) {
                state.form.oneTimeBindingValues[oneTimeBindingKey] = result;
              }
            }
          } else {
            for (let index = matches.length - 1; index >= 0; index--) {
              const match = matches[index];
              const matchStr = match[0];
              const matchIndex = match["index"];

              let computedValue = "";

              let oneTimeBindingKey = `${elementId}${
                property ? "_" + property : ""
              }_${matchIndex}`;
              if (oneTimeBindingKey in state.form.oneTimeBindingValues) {
                computedValue =
                  state.form.oneTimeBindingValues[oneTimeBindingKey];
              } else {
                let isOneTimeBinding = false;
                let toComputeValue = matchStr.slice(2, matchStr.length - 2);
                if (toComputeValue.startsWith("::")) {
                  isOneTimeBinding = true;
                  toComputeValue = toComputeValue.slice(
                    2,
                    toComputeValue.length
                  );
                }
                computedValue = getters.computeFormSubmitterValue({
                  elementId,
                  property,
                  value: "computed:" + toComputeValue,
                  defaultValue,
                  form,
                  statements,
                  preCode
                });

                if (isOneTimeBinding && hasValue(result)) {
                  state.form.oneTimeBindingValues[oneTimeBindingKey] =
                    computedValue;
                }
              }
              result =
                result.substring(0, matchIndex) +
                computedValue +
                result.substring(matchIndex + matchStr.length);
            }
          }
          getters.computeFormSubmitterValue({
            elementId,
            property: "value",
            value: result,
            defaultValue: "",
            form,
            preCode
          });
        }
        return result;
      },
    getFormSubmitById: () => async (id) => {
      return await formSubmitterServer.get(id);
    }
  }
};

export default formSubmitterModule;
